import { isTouchDevice } from './detect-touch-device';
import 'headroom.js';

const $win = $(window);
const $doc = $(document);

const $header = $('.header');
const $fixedNavigation = $('.js-fixed-navigation');
const $navDropdownParent = $('.header__inner .nav > ul > .nav__has-dropdown, .header__inner .nav-utilities > ul > .nav-utilities__has-dropdown');

/**
   * Show nav dropdowns for mobile devices
   * @param  { Object } $clickedElement DOM Element - clicked element
   * @return { Void }
   */
function showNavDropdownsForMobile($clickedElement) {
  if (isTouchDevice()) {
    $clickedElement
      .toggleClass('is-active')
      .next('.nav__dropdown, .nav-utilities__dropdown')
      .slideToggle()
      .closest('li')
      .siblings()
      .find('.is-active')
      .removeClass('is-active')
      .next('.nav__dropdown, .nav-utilities__dropdown')
      .slideUp();
  } else {
    $clickedElement.parent().addClass('is-active').siblings().removeClass('is-active');
  }
}

/**
   * Hide nav dropdowns for mobile devices
   * @param  { Object } event Event on page
   * @return { Void }
   */
function hideNavDropdownsForMobile(event) {
  const $element = $(event.target);

  if (!$element.parents().hasClass('nav') && !$element.parents().hasClass('nav-utilities')) {
    if ($win.width() > 767) {
      $navDropdownParent.find('.is-active').removeClass('is-active');
    } else {
      $navDropdownParent.find('.nav__dropdown[style="display: block;"], .nav-utilities__dropdown[style="display: block;"]').slideUp();
      $navDropdownParent.removeClass('is-active').find('.is-active').removeClass('is-active');
    }
  }
}

$navDropdownParent.find(' > a').on('touchstart mouseenter', function(event) {
  event.stopPropagation();
  event.preventDefault();
  var $this = $(this);
  $header.find('.is-active').not($this).removeClass('is-active');
  $this
    .toggleClass('is-active')
});



$header.on('mouseleave', function() {
  if ($win.width() >= 1024 && !isTouchDevice()) {
    $header.find('.is-active').removeClass('is-active');
  }
})

$('.nav-mobile .nav > ul > .nav__has-dropdown > a, .nav-mobile .nav-utilities > ul > .nav-utilities__has-dropdown > a').on('click', function(event) {
  if (isTouchDevice() || $win.width() < 1024) {
    event.preventDefault();
    showNavDropdownsForMobile($(this));
  }
});

// $navDropdownParent.find('> a').on('click', function(event) {
//   if (isTouchDevice() || $win.width() < 1024) {
//     event.preventDefault();
//     showNavDropdownsForMobile($(this));
//   }
// });

$doc.on('touchstart', function(event) {
  if (isTouchDevice()) {
    hideNavDropdownsForMobile(event);
  }
});

$('.js-fixed-navigation .current > a').on('click', function(event) {
  if ($win.width() < 768) {
    event.preventDefault();

    $(this).closest('.js-toggle').removeClass('is-expanded').slideUp().prev().removeClass('is-active');
  }
});

if ($fixedNavigation.length) {
  const header = new Headroom($header[0], {
    classes: {
      unpinned: 'is-hidden'
    }
  });
  header.init();

  const nav = new Headroom($fixedNavigation[0], {
    classes: {
      unpinned: 'is-top'
    }
  });
  nav.init();
}

/**
 * Always show the blue header on mobile when the nav is open
 */
$('.btn-menu').on('click', function(event) {
  $('.header').toggleClass('nav-opened');
});



// WEBPACK FOOTER //
// ./../src/assets/js/navigation.js